export const getPaymentIntentQuery = `query getPaymentIntent($amount: Int! $currency: Currency!){
  getPaymentIntent(amount: $amount currency: $currency) {
    client_secret
    amount
    currency
  }
}`
